<template>
    <main>
        <h1>404</h1>

        <p>An error has occurred.</p>
    </main>
</template>
